import React, { useEffect, useRef } from 'react'
import { Button, Drawer, Input, Form, Switch } from 'antd'
import { SiteType } from '@merchx-v2/shared-types'
import notification from 'mrx-notification'
import { useCreatePage } from '../../hooks'
import styles from './CreatePage.module.scss'

type PropsType = {
  ownerType: SiteType
  ownerId: number
  isVisible: boolean
  onClose: () => void
  onPageCreated: (pageId: number) => void
}

const CreateTemplatePage = (props: PropsType) => {
  const refEl = useRef<Input>(null)

  const { ownerType, ownerId, isVisible, onClose, onPageCreated } = props

  const createPage = useCreatePage()

  const [form] = Form.useForm()

  useEffect(() => {
    if (isVisible === true) {
      refEl.current && refEl.current.focus()
    }
  })

  const handleClose = () => {
    form.resetFields()
    onClose()
  }

  const onFinishHandler = async (values: any) => {
    createPage.mutate(
      {
        ownerType,
        ownerId,
        pageData: {
          name: values.name,
          route: values.route,
          canBeSkippedOnBuild: values.canBeSkippedOnBuild,
          goalName: values.goalName
        }
      },
      {
        onSuccess: (data) => {
          notification.success({
            message: 'Successfully',
            description: 'Template Page was created successfully!'
          })
          onPageCreated(data.id)
          handleClose()
        },
        onError: (error) => {
          notification.error({
            message: 'Error!',
            description: error.toString()
          })
        }
      }
    )
  }

  return (
    <Drawer title='Create Template Page' width='400' onClose={handleClose} visible={isVisible} forceRender>
      <Form layout='vertical' hideRequiredMark onFinish={onFinishHandler} form={form}>
        <Form.Item name='name' label='Name' rules={[{ required: true, message: 'Please input template page name!' }]}>
          <Input type='text' ref={refEl} />
        </Form.Item>
        <Form.Item name='route' label='Route' rules={[{ required: true, message: 'Please input template page route!' }]}>
          <Input />
        </Form.Item>
        <Form.Item
          name='canBeSkippedOnBuild'
          label='Can be skipped on bulid'
          valuePropName='checked'
          initialValue={false}
          rules={[{ required: true, message: 'Please select a value!' }]}
        >
          <Switch checkedChildren='true' unCheckedChildren='false' />
        </Form.Item>
        {ownerType === 'TEMPLATE' && (
          <Form.Item name='goalName' label='Funnel goal name'>
            <Input type='text' />
          </Form.Item>
        )}
        <div
          style={{
            position: 'absolute',
            left: 0,
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e9e9e9',
            padding: '10px 16px',
            background: '#fff',
            textAlign: 'right'
          }}
        >
          <Button onClick={handleClose} className={styles.closeButton}>
            Close
          </Button>
          <Button type='primary' htmlType='submit' loading={createPage.isLoading}>
            Create
          </Button>
        </div>
      </Form>
    </Drawer>
  )
}

export default CreateTemplatePage
